import React, {useContext, useEffect} from 'react'
import AuthContext from '../../context/auth/AuthContext'
import { withComponentLabel } from '../../utils/debug'

const Authorizer = (props) => {
  const authContext = useContext(AuthContext)
  const {loadUser} = authContext
  useEffect(() => {
    console.log('Authorizer loading user')
    loadUser()
  }, [])
  return <div>{props.children}</div>
}

export default withComponentLabel(Authorizer, 'Authorizer')
